module.exports = __webpack_public_path__ + "img/logo-get-response.65ec0104.png";